var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-group', {
    class: _vm.formGroupClass
  }, [_c('validation-provider', {
    attrs: {
      "name": _vm.labelName,
      "rules": _vm.rules
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(validationContext) {
        return [_c('label', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.computedLabel)
          }
        })]), _c('multiselect', {
          class: _vm.selectClassName(validationContext),
          attrs: {
            "name": _vm.labelName,
            "options": _vm.options,
            "custom-label": _vm.customLabel,
            "multiple": true,
            "searchable": true,
            "placeholder": _vm.computedPlaceholder,
            "close-on-select": false,
            "clear-on-select": false,
            "preserve-search": true,
            "hide-selected": false,
            "show-no-results": false,
            "loading": _vm.isLoading,
            "options-limit": _vm.optionsLimit,
            "internal-search": _vm.localSearch,
            "local-search": _vm.localSearch,
            "showNoResults": true,
            "taggable": _vm.isTaggable,
            "max-height": _vm.maxHeight,
            "tag-placeholder": _vm.tagPlaceholder
          },
          on: {
            "remove": _vm.removeHandler,
            "select": _vm.selectHandler,
            "input": _vm.toggleHandler,
            "focus": _vm.autoCompleteHandler,
            "search-change": _vm.searchHandler,
            "open": _vm.openHandler,
            "tag": _vm.addTag
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function fn(_ref) {
              var values = _ref.values;
              return _vm.showSelections ? [values.length ? _c('span', {
                staticClass: "multiselect__single"
              }, [_vm._v(" " + _vm._s(values.includes("all") ? "All " : values.length) + " Options Selected ")]) : _vm._e()] : undefined;
            }
          }], null, true),
          model: {
            value: _vm.computedInputData,
            callback: function callback($$v) {
              _vm.computedInputData = $$v;
            },
            expression: "computedInputData"
          }
        }), _c('div', {
          staticClass: "error-text"
        }, [_c('span', [_vm._v(_vm._s(_vm.errorField ? _vm.errorField[0] : validationContext.errors[0]))])])];
      }
    }])
  }), _vm._t("info-div")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }